import '../static/Grid.css';
import React__default, { forwardRef } from "react";
import clsx from "clsx";
import { u as useTagName } from "./useTagName.COq0HFfN.mjs";
const grid = `_grid_ec39c3b`;
const left = `_left_6830456`;
const center = `_center_e73124d`;
const right = `_right_3402f36`;
const styles = { grid, left, center, right };
const GRID_X_ALIGN = ["left", "center", "right"];
const Grid = forwardRef(
  ({ as, className, xAlign = "left", ...props }, ref) => {
    const Component = useTagName(as);
    return /* @__PURE__ */ React__default.createElement(
      Component,
      {
        "data-ui-grid": true,
        ref,
        className: clsx(styles.grid, styles[xAlign], className),
        ...props
      }
    );
  }
);
export {
  GRID_X_ALIGN as G,
  Grid as a
};
//# sourceMappingURL=Grid.QyNjlydO.mjs.map
